export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase()
  })
}

const FONT_SCALE: Record<string, number> = {
  Futura: 1,
  Flamboyan: 2,
  BrushScript: 1.5,
  CenturyGothic: 1,
  default: 1,
}

export function getNormalizedFontSize(fontSize: number, fontFamily: string) {
  const scale = FONT_SCALE[fontFamily] ?? FONT_SCALE.default
  return fontSize * scale
}
